import React from 'react';
import BestValueCard from '@fff-web/fff-ui-shared/BestValueCard';
import { useUpgradeMembershipContext } from '../../../../utils/ContextProviders/UpgradeContext';
import TitleDuoTone from '@fff-web/fff-ui-shared/TitleDuoTone';
import useGetPricesByPlan from '../../../../utils/hooks/useGetPricesByPlan';
import styles from './BestValueContainer.module.scss';

const BADGE_TEXT = 'Best Value';

const title = {
  text: 'Annual Members Save Over $1,702* a Year',
  textToChangeColor: '$1,702',
  color: '#fb6a66',
};

const BestValueContainer = () => {
  const { growthUpgrade } = useUpgradeMembershipContext();
  const { annualPrice } = useGetPricesByPlan();

  const formattedAnnualPrice =
    annualPrice && `$${annualPrice?.annualPrice}/year`;
  const { text, textToChangeColor } = title;

  return (
    <section className={styles.bestValueWrapper}>
      <TitleDuoTone text={text} textToChangeColor={textToChangeColor} />
      <BestValueCard
        badge={BADGE_TEXT}
        plan={{
          name: 'Annual',
          price: formattedAnnualPrice,
        }}
        size="large"
      />
    </section>
  );
};

export { BestValueContainer };
